// extracted by mini-css-extract-plugin
export default {"wrap":"Burger-module--wrap--3b491","open":"Burger-module--open--96cfb"};